import React from 'react'
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';

export default function ModalExportComponent({ selectedItem, orderType, Close
  , handlePackageItemSubmit, handleInnerFormChange }: any) {


  return (

    <div className="  w-full p-2 bg-white shadow-md rounded-md">
      <h1 className="text-xl font-bold mb-4 text-center">Export the Order list</h1>
      <div className=' grid grid-cols-1 gap-4'>
        <InputContainer
          label="Order Type"
          labelField="Description"
          list={orderType}
          onValueChange={(event: any, newValue: any) => {
            handleInnerFormChange(
              event.target.value,
              'LogisticsOrderTypeId'

            );
          }}
          optionName='Choose OrderType'
          type="select"
          value={selectedItem?.LogisticsOrderTypeId}
          valueField="Value"
        />

      </div>

      <div className="flex justify-end mt-6">
        <button
          onClick={Close}
          type="button"
          className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
        >
          Close
        </button>
        <button
          className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
          onClick={handlePackageItemSubmit}
          type="submit"
        >
          Save
        </button>
      </div>

    </div>



  )
}